<template>
  <div>
    <label :for="handle">{{ label }}</label>
    <v-select label="bezeichnung"
              :item-value="itemValue"
              :item-text="itemText"
              :options="options"
              :disabled="disabled"
              v-model="value"
              :key="'fcl-'+criteriaId+'-'+changeCounter"
              :placeholder="placeholder"
              :multiple="multiple"
              :class="inputClass">
      <span slot="no-options">Filteroptionen werden geladen...</span>
      <div slot="open-indicator" class="vs__open-indicator"></div>
    </v-select>
  </div>
</template>
<style></style>
<script>
export default {
  name: "filter-criteria-list",
  props: {
    label: String,
    handle: String,
    criteriaId: Number,
    placeholder: String,
    disabled: Boolean,
    viewFilters: String,
    itemValue: {
      type: String,
      default: 'code'
    },
    itemText: {
      type: String,
      default: 'bezeichnung'
    },
    value: [Object, Boolean, Array],
    optionsEndpoint: String,
    optionsInit: Array,
    multiple: Boolean,
    inputClass: String,
  },
  data: function () {
    return {
      changeCounter: 0,
      selectedOptionsLoaded: false,
      options: []
    }
  },
  computed: {
    completeOptionsEndpoint: function () {
      if(this.optionsEndpoint){
        return this.optionsEndpoint.replace('{code}', this.criteriaId);
      }
      return null;
    }
  },
  watch: {
    optionsInit: function(newVal, oldVal) {
      this.changeCounter++;
      this.options = newVal;
    },
    value: function(newVal, oldVal) {
      if(newVal && newVal.code === 0){
        this.value = null;
        return;
      }
      if(newVal && newVal.bezeichnung === undefined && newVal.code !== null && this.options.length > 0){
        let t = this.options.find(function(o){
          return o.code == newVal.code;
        });
        if(t)this.value.bezeichnung = t.bezeichnung;
      }
      this.$emit('input', newVal);
    },
  },
  methods: {
    getOptions: function () {
      var self = this;
      var ep = this.completeOptionsEndpoint;
      if(this.viewFilters) ep = ep + '?' + this.viewFilters;
      axios.get(ep)
          .then(function(response){
            if(self.placeholder){
              self.options = [{code:0,bezeichnung:self.placeholder},...response.data];
            } else {
              self.options = response.data;
            };
            self.updateValue();
          });
    },
    updateValue: function(){
      if(!this.value) return;
      var value = this.value;
      if(this.options.some(function(o){
        return JSON.stringify(o) == JSON.stringify(value);
      })) return;
      if(typeof value == 'object' && value instanceof Array){
        var selected = [];
        var options = this.options;
        value.forEach(function(item){
          selected.push(options.find(function(o){
            return o.code == item;
          }))
        });
      }
      else if(typeof value == 'object'){
        var selected = this.options.find(function(o){
          return o.code == value.code || o.code == value[0];
        });
      }
      else if(typeof value == 'string'){
        var selected = this.options.find(function(o){
          return o.code == value;
        });
      }
      if(selected)this.value = selected;
    }
  },
  mounted() {
    if(this.optionsEndpoint){
      this.getOptions();
    } else {
      this.options.push(...this.optionsInit);
      this.updateValue();
    };
  }
}
</script>